import {
  AutonomousTaskStopped,
  BatteryDeepDischarge,
  CleaningTaskFinished,
  EmergencyStop,
  ErrorOccured,
  LocationStatus,
  Resources,
  ServiceNeeded
} from 'assets/images';

export const STATE_PROP = 'notifications';

export const TYPES = {
  RESOURCES: { id: 'RESOURCES', icon: <Resources /> },
  ERROR_OCCURRED: {
    id: 'ERROR_OCCURRED',
    icon: <ErrorOccured />
  },
  BATTERY_DEEP_DISCHARGE: {
    id: 'BATTERY_DEEP_DISCHARGE',
    icon: <BatteryDeepDischarge />
  },
  AUTONOMOUS_TASK_STOPPED: {
    id: 'AUTONOMOUS_TASK_STOPPED',
    icon: <AutonomousTaskStopped />
  },
  SERVICE_NEEDED: {
    id: 'SERVICE_NEEDED',
    icon: <ServiceNeeded />
  },
  LOCATION_STATUS: {
    id: 'LOCATION_STATUS',
    icon: <LocationStatus />
  },
  CLEANING_TASK_FINISHED: {
    id: 'CLEANING_TASK_FINISHED',
    icon: <CleaningTaskFinished />
  },
  EMERGENCY_STOP: {
    id: 'EMERGENCY_STOP',
    icon: <EmergencyStop />
  },
  UNDEFINED: {
    id: 'UNDEFINED',
    icon: ''
  }
};

export const NOTIFICATION_SEVERITY = {
  ALERT: 'ALERT',
  NEED_FOR_ACTION: 'NEED_FOR_ACTION',
  INFORMATIVE: 'INFORMATIVE'
};

export const MAPPING_SEVERITY_CLASS_NAME_BY_SEVERITY_ENUM = {
  ALERT: 'alert',
  NEED_FOR_ACTION: 'needForAction',
  INFORMATIVE: 'informative'
};
